import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import NewNewProductPage from './product/NewNewProductPage';

const CONFIG = {
  ro: {
    title: 'Cursuri de limbi străine bazate pe situații reale',
    description:
      'Învață din situații din viața reală, sprijinite de înțelegerile vorbitorilor nativi.',
  },
};

const ProductPage = ({ data }) => {
  const { lang } = useParams();

  useEffect(() => {
    document.title = CONFIG[lang]?.title;
    document.getElementsByName('description')[0].content =
      CONFIG[lang]?.description;
  }, [lang]);

  return <NewNewProductPage data={data.product_page} />;
};

export default ProductPage;
